// extracted by css-extract-rspack-plugin
export default {"message":"Xrqiyhp8GYHwGyk3"};